/* Appearance only. Native Shopify forms, sections, navigation and apps retain ownership. */
(() => {
  const root = document.documentElement;
  if (!root.hasAttribute('data-loc-appearance')) return;
  const compactFooter = window.matchMedia('(max-width: 749px)');
  const footerGroups = new WeakSet();
  const syncFooter = (reset = false) => {
    document.querySelectorAll('.loc-footer-group').forEach((group) => {
      if (reset || !footerGroups.has(group)) group.open = !compactFooter.matches;
      footerGroups.add(group);
      const summary = group.querySelector('summary');
      if (compactFooter.matches) {
        summary.removeAttribute('tabindex');
        summary.removeAttribute('aria-disabled');
      } else {
        summary.setAttribute('tabindex', '-1');
        summary.setAttribute('aria-disabled', 'true');
      }
    });
  };
  compactFooter.addEventListener('change', () => syncFooter(true));
  document.addEventListener('shopify:section:load', () => syncFooter());
  const apply = (value) => {
    const mode = value === 'dark' ? 'dark' : 'light';
    root.dataset.locAppearance = mode;
    document.querySelectorAll('[data-loc-appearance-choice]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.locAppearanceChoice === mode));
    });
    document.querySelectorAll('[data-loc-appearance-controls]').forEach((group) => { group.hidden = false; });
  };
  document.addEventListener('click', (event) => {
    if (!compactFooter.matches && event.target.closest('.loc-footer-group > summary')) event.preventDefault();
    const button = event.target.closest('[data-loc-appearance-choice]');
    if (!button) return;
    const mode = button.dataset.locAppearanceChoice;
    if (!['dark', 'light'].includes(mode)) return;
    apply(mode);
  });
  // Dark is an optional view for this page, never the next visit's default.
  // Ignore legacy localStorage choices, including cached dark preferences.
  window.addEventListener('pageshow', () => apply('light'));
  document.addEventListener('shopify:section:load', () => apply(root.dataset.locAppearance));
  apply('light');
  syncFooter();
})();
